import { createTheme } from "@mui/material";

export const THEME = createTheme({
  palette: {
    primary: {
      main: "#ce5b11",
      dark: "#903F0B",
      light: "#D77B40",
    },
    secondary: {
      main: "#212121",
      dark: "#171717",
      light: "#4D4D4D",
      contrastText: "#fff",
    },
    error: {
      main: "#F44336",
      light: "#E57373",
      dark: "#D32F2F",
    },
    warning: {
      main: "#FFA726",
      dark: "#F57C00",
      light: "#FFB74D",
      contrastText: "rgba(255,255,255,0.87)",
    },
    info: {
      main: "#29B6F6",
      dark: "#0288D1",
      light: "#4FC3F7",
    },
    success: {
      main: "#66BB6A",
      dark: "#388E3C",
      light: "#81C784",
      contrastText: "#fff",
    },
    background: {
      default: "#f7f7f7",
      paper: "#fff",
    },
  },
  zIndex: {
    drawer: 1200,
  },
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "2rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "1.5rem",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
  },
});

export const GLOBAL_STYLES = () => ({
  "*": {
    "::-webkit-scrollbar": {
      width: "0.2rem",
      height: "0.2rem",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      "background-color": THEME.palette.primary.main,
      "border-radius": "0.2rem",
    },
    "::-webkit-scrollbar-thumb:hover": {
      "background-color": THEME.palette.primary.main,
    },
  },
  "html,body,#root": {
    margin: 0,
    padding: 0,
    height: "100%",
  },
  html: {
    fontFamily: "Poppins, sans-serif",
    // color: "#fff",
    "*::selection": {
      background: THEME.palette.primary.main,
      color: THEME.palette.primary.contrastText,
    },
    // Variável global para spacing responsivo
    "--page-spacing": "2rem",
    // Variáveis globais para padding das modais (valores reduzidos pela metade)
    "--modal-padding-large": "2.5rem",
    "--modal-padding-medium": "2rem",
    "--modal-padding-small": "1.5rem",
  },
  body: {
    background: THEME.palette.background.default,
  },
  "#root": {
    display: "flex",
  },
  "@media only screen and (max-width: 900px)": {
    html: {
      "--page-spacing": "1rem",
      "--modal-padding-large": "1.25rem",
      "--modal-padding-medium": "1rem",
      "--modal-padding-small": "0.75rem",
    },
  },
  "@media only screen and (min-width: 0px)": {
    html: {
      fontSize: "14px",
    },
  },
  "@media only screen and (min-width: 960px)": {
    html: {
      fontSize: "16px",
    },
  },
  "@media only screen and (min-width: 1280px)": {
    html: {
      fontSize: "18px",
    },
  },
  "@media only screen and (min-width: 1920px)": {
    html: {
      fontSize: "20px",
    },
  },
});
